import MultifocalComponent from 'components/MultifocalPage/MultifocalComponent';
import { StaticContentPage } from 'constants/notionDataPages';
import { FC, useEffect } from 'react';
import notionDataService from 'services/notiondata.service';
import { extractImgAttributesAndRemoveTag, getSeoBlockContent, getSeoMetaTags } from 'utils/common.utils';
import { useRouter } from 'next/router';
const MultifocalPage: FC<StaticContentPage> = ({
    title,
    content,
    publishDate,
    seoBlock,
    seoMetaTags,
    locale,
    cover
}) => {
    const router = useRouter();
    useEffect(() => {
        if (locale == "international") {
            router.replace('/multifocals');
        }
    }, [locale]);

    return (
        <MultifocalComponent
            title={title}
            content={content}
            publishDate={publishDate}
            seoBlock={seoBlock}
            seoMetaTags={seoMetaTags}
            locale={locale}
            cover={cover} />
    );

};


export const getServerSideProps = async ({
    locale
}: {
    locale: string;
}) => {


    if (locale == "nz") {
        //redirect to multifocals page
        return {
            redirect: {
                destination: '/nz/progressives',
                permanent: false,
            },
        }
    }

    if (locale == "ca") {
        //redirect to multifocals page
        return {
            redirect: {
                destination: '/ca/progressives',
                permanent: false,
            },
        }
    }

    const pageSlug = 'multifocals';
    // Perform any necessary data fetching or processing here
    // For example, you can fetch data from an API based on the landingPage and locale
    const pageData: any = await notionDataService.getPageList('static_page/page_' + pageSlug, locale, true);

    //Filter pageData with params.landingPage.slug and handle non existing case
    const selectedPages = pageData.filter((page: StaticContentPage) => page.slug == pageSlug);

    //If no page is found, return 404
    if (selectedPages.length === 0) {
        return {
            notFound: true,
        }
    }

    const selectedPageData = selectedPages[0];

    const article = await notionDataService.getPageDetail('static_page/page', selectedPageData.id, locale, false);
    if (!article) {
        return {
            notFound: true,
        }
    }
    const { attributes } = extractImgAttributesAndRemoveTag(article.content);


    const seoBlock = await getSeoBlockContent(pageSlug, locale);
    const seoMetaTags = await getSeoMetaTags('/' + pageSlug, locale);


    return {
        props: {
            title: "Multifocal Lenses",
            publishDate: selectedPageData.publishDate,
            content: article.content,
            seoBlock,
            seoMetaTags,
            locale,
            cover: attributes

        }
    };
};
export default MultifocalPage;
